var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-paragraph mb-5",attrs:{"id":"skeletonParagraph"}},[(_vm.showTitle)?_c('div',{staticClass:"skeleton-title"}):_vm._e(),_vm._l((_vm.rows),function(index){return _c('div',{key:index,staticClass:"skeleton-line"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }